import { AnalyticsEvent } from './../constants/AnalyticsEvents';
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor() {}

  trackScreen(url: string): void {
    this.pushEvent('screen_view', { firebase_screen: url });
  }

  logClickEvent(eventName: AnalyticsEvent | string): void {
    this.pushEvent('click', { name: eventName });
  }

  logCustomEvent(eventName: AnalyticsEvent | string): void {
    this.pushEvent(eventName);
  }

  private pushEvent(name: string, params: any = null) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      params,
    });
  }
}
